import { useAuthStore } from '@/store/auth.store';
import { useBootstrapStore } from '@/store/bootstrap.store';
import { login as apiLogin, logout as apiLogout } from '@/services/auth/auth.service';
import { clearTenantConfigCache } from '@/services/bootstrap/bootstrap.service';
import type { LoginResponse } from '@/services/auth/login-result.interface';
import { logger } from '@/lib/logger';

export const useAuth = () => {
  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);
  const tenantId = useAuthStore((state) => state.tenantId);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const login = useAuthStore((state) => state.login);
  const logout = useAuthStore((state) => state.logout);

  const signIn = async (idToken: string): Promise<LoginResponse> => {
    const result = await apiLogin(idToken);
    login(result.accessToken, result.user, result.tenantId);
    return result;
  };

  const signOut = async (): Promise<void> => {
    try {
      await apiLogout();
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : String(error);
      logger.warn('Logout API call failed, but proceeding with local logout', {
        error: errorMessage,
      });
    } finally {
      clearTenantConfigCache();
      useBootstrapStore.getState().reset();
      logout();
    }
  };

  return {
    token,
    user,
    tenantId,
    isAuthenticated,
    signIn,
    signOut,
  };
};
